import { Route, Routes, Navigate } from "react-router-dom"

import Layout from "@/components/molecules/Layout"
import { usePermissions } from "@/hooks/usePermissions"

import Customers from "./Customers"
import CustomerDetail from "./CustomerDetail"
import Fidelity from "./Fidelity"
import Rewards from "./Rewards"
import Reports from "./Reports"
import Settings from "./Settings"

// ----------------------------------------------------------------------------

export default function LoggedApp() {
  const { canViewSettings } = usePermissions()

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/customers" replace />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/:id" element={<CustomerDetail />} />
        <Route path="/fidelity" element={<Fidelity />} />
        <Route path="/rewards" element={<Rewards />} />
        <Route path="/reports" element={<Reports />} />
        {canViewSettings ? (
          <Route path="/settings" element={<Settings />} />
        ) : (
          <Route path="/settings" element={<Navigate to="/customers" replace />} />
        )}
      </Routes>
    </Layout>
  )
}
